<template>
  <div class="common_aside">
    <h3 class="title">资源库</h3>
    <ul class="list_box">
      <li
        v-for="(item, index) in asideArr" :key="item.cat2 || item.cat1" v-report:mainclick="{ area: 'leftbar', pos: index }" class="list_item"
        :class="{ active: activeIndex === index }" @click="clickChangeActiveIndex(index)"><span class="font">{{ item.name }}</span></li>

      <!-- 注意上报是4，上面变化4也应该要变 -->
      <li v-report:mainclick="{ area: 'leftbar', pos: 4 }" class="list_item" @click="clickMoreHandle"><span class="font">更多</span></li>
    </ul>
  </div>
</template>

<script>
import { ClientOpenTemplateByUrl } from '@/api/clientApi.js'
import { urlClientMore } from '@/common/resources.js'

export default {
  name: 'Aside',

  data () {
    return {
      active: 0
    }
  },

  inject: {
    isErrorPage: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    asideArr () {
      return this.$store.state.home.asideArr
    },

    activeIndex () {
      return this.$store.state.activeIndex
    }
  },

  methods: {
    clickChangeActiveIndex (index) {
      this.isErrorPage && this.$router.push('/') // 错误页面重置
      this.$emit('changeActiveIndex', index)
    },

    clickMoreHandle () {
      ClientOpenTemplateByUrl(urlClientMore)
    }
  }
}
</script>

<style lang="scss" scoped>
.common_aside {
  width: 69px;
  height: 100%;
  background-color: #fff;
  border-right: 1px solid $border_color;

  .title { padding: 15px 0; margin-bottom: 10px; font-size: 16px; text-align: center; border-bottom: 1px solid $border_color; }

  .list_item {
    position: relative;
    height: 76px;
    text-align: center;
    cursor: pointer;
    background-repeat: no-repeat;
    background-position: center 15px;
    background-size: 28px 28px;

    &:hover {
      background-color: #eef0f7;
      &:nth-child(1) { background-image: url(~@/assets/images/icon_aside_model_hover.svg); }
      &:nth-child(2) { background-image: url(~@/assets/images/icon_aside_icon_hover.svg); }
      &:nth-child(3) { background-image: url(~@/assets/images/icon_aside_icon2_hover.svg); }
      &:nth-child(4) { background-image: url(~@/assets/images/icon_aside_bg_hover.svg); }
      &:nth-child(5) { background-image: url(~@/assets/images/icon_aside_illustration_hover.svg); }
      &:nth-child(6) { background-image: url(~@/assets/images/icon_aside_more_hover.svg); }
    }

    &.active {
      background-color: #fff !important;
      &:nth-child(1) { background-image: url(~@/assets/images/icon_aside_model_active.svg); }
      &:nth-child(2) { background-image: url(~@/assets/images/icon_aside_icon_active.svg); }
      &:nth-child(3) { background-image: url(~@/assets/images/icon_aside_icon2_active.svg); }
      &:nth-child(4) { background-image: url(~@/assets/images/icon_aside_bg_active.svg); }
      &:nth-child(5) { background-image: url(~@/assets/images/icon_aside_illustration_active.svg); }
      &:nth-child(6) { background-image: url(~@/assets/images/icon_aside_more_active.svg); }
      .font { color: $font_color; }
    }
    &:nth-child(1) { background-image: url(~@/assets/images/icon_aside_model.svg); }
    &:nth-child(2) { background-image: url(~@/assets/images/icon_aside_icon.svg); }
    &:nth-child(3) { background-image: url(~@/assets/images/icon_aside_icon2.svg); }
    &:nth-child(4) { background-image: url(~@/assets/images/icon_aside_bg.svg); }
    &:nth-child(5) { background-image: url(~@/assets/images/icon_aside_illustration.svg); }
    &:nth-child(6) { background-image: url(~@/assets/images/icon_aside_more.svg); }

    .font { position: absolute; top: 50px; left: 0; width: 100%; font-size: 12px; color: #9497ac; }
  }
}
</style>
